import * as React from "react";
import ReactDOM from "react-dom/client";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@components/ui/dialog";
import CustomWidget from "./Widget";
import {
  BriefcaseIcon,
  ComputerIcon,
  InfoIcon,
  MailIcon,
  PhoneIcon,
  UserIcon,
  LoaderIcon,
  // Trash,
} from "lucide-react";
import { Switch } from "@components/ui/switch";
import { Label } from "@components/ui/label";
import HeatMap from "./charts/HeatmapChart";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@components/ui/tabs";
import LineChart from "./charts/LineChart";
import DataTable from "./DataTable";
import { Card } from "../ui/card";
import {
  getuserDetails,
  getPluginFrontend,
  getAvailablePluginCategories,
  getPeerUsers,
  userEntitySessions,
  // getOtherUserAttributes,
  getUserDetailsAnomalies,
} from "@services/api/commonApis";
import { updateUserAttributeProps } from "@pages/homepage/identityIntelligence/identityIntelligenceType";
import {
  updateUserAttribute,
  // changeUserAttribute,
  userGroupDetails,
  deleteUser,
} from "@services/api/identityIntelligence";
import { useQuery, useMutation, useQueryClient } from "react-query";
import AnomalyDetail from "./AnomalyDetail";
import TimeFilter from "./TimeFilter";
import { useToast } from "@components/ui/use-toast";
import DialogLoader from "../loaders/DialogLoader";
import TableLoader from "../loaders/TableLoader";
import NoData from "./NoDataLabel";
import { Checkbox } from "@components/ui/checkbox";
import AnomalyFixedDialog from "@pages/homepage/aml-anomaly-detection/AnomalyFixedDialog";
import { AssetEntityInspectorContent } from "@pages/homepage/asset-auto-discovery/AssetEntityInspector";
import ShadowGPTFloat from "@components/common/ShadowGPTFloat";
import AMLDropdownmenu from "@pages/homepage/aml-anomaly-detection/AmlDropdownmenu";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@components/ui/tooltip";
import { UserInvestigatorProps } from "./CommonTypes";
import { EpochToDateTime } from "@utils/utils";
import { Button } from "../ui/button";
import { GeneralContext } from "@services/providers/GeneralProvider";
import { Input } from "../ui/input";
import {
  isFeatureAllowed,
  ALL_KEYS,
  getFeatureValues,
} from "@utils/licenseUtils";
import Sources from "./ddr/Sources";
import Summary from "./ddr/Summary";
import Services from "./ddr/Services";
import SensitivityDataByCategory from "@pages/homepage/sensitive-data/widgets/SensitivityDataByCategory";
import { getInstalledPluginList } from "@services/api/ddrCommonApis";
import ConfirmDialog from "@components/common/ConfirmDialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import PluginEnv from "@pages/homepage/plugins/PluginEnvironment";
import { UserProp } from "./ddr/ddrTypes";
import { getUserDeails } from "@services/api/ddrIdentityIntelligence";

const userAccessHeader: any = [
  { header: "First Activity", accessor: "firstActivity" },
  { header: "Last Activity", accessor: "lastActivity" },
  { header: "Hostname", accessor: "hostname" },
  { header: "IP", accessor: "ip" },
];

const userGroupCols = [
  { header: "Group Name", accessor: "groupname" },
  // { header: "Source", accessor: "source" },
];

const UserInvestigator: React.FC<UserInvestigatorProps> = React.memo(
  ({
    account = "",
    openState,
    onClose,
    filter_time = "day",
    is_external = false,
    pluginId = "",
    tenantId = "",
    source = "",
  }) => {
    const { theme, permissions } = React.useContext(GeneralContext);
    // const { permissions, isAdminUser, theme } = React.useContext(GeneralContext);
    const { toast } = useToast();
    const userInvestigatorAccessKey = ALL_KEYS.USER_INVESTIGATOR_ACCESS;
    const hasUserInvestigatorFeature = isFeatureAllowed(
      userInvestigatorAccessKey,
    );
    const hasUserInvestigatorPermission = permissions.includes(
      userInvestigatorAccessKey,
    );
    const hasUserInvestigatorAccess =
      hasUserInvestigatorFeature && hasUserInvestigatorPermission;
    const [_pluginId, set_pluginId] = React.useState("");
    const [_tenantId, set_tenantId] = React.useState("");
    const [_source, set_source] = React.useState("");
    const [anomalyActionData, setAnomalyActionData] = React.useState<any>([]);
    const [showAnomalyFix, setShowAnomalyFix] = React.useState(false);
    const [showNotExists, setShowNotExists] = React.useState<boolean>(false);
    const [deleting, setDeleting] = React.useState(false);
    const [deletedUserPopUp, setDeletedUserPopUp] =
      React.useState<boolean>(false);
    const [userScore, setUserScore] = React.useState(0);
    const [anomalyDetailOpen, setanomalyDetailOpen] = React.useState(false);
    const [anomalyId, setAnomalyId] = React.useState(0);
    const filterAnomalyId = 0;
    // const [filterAnomalyId, setFilterAnomalyId] = React.useState(0);
    const [anomalyChartData, setAnomalyChartData] = React.useState<any>([]);
    const [userDetails, setUserDetails] = React.useState<any>(null);
    const [timeFrame, setTimeFrame] = React.useState(filter_time);
    const [extraTabs, setExtraTabs] = React.useState<any>([]);
    const [pluginDataParams, setPluginDataParams] = React.useState<any>(null);
    const [userAttributeDialog, setUserAttributeDialog] = React.useState(false);
    const [userDefaultAttributeRows, setDefaultUserAttributeRows] =
      React.useState<any>([]);
    const [userCustomAttributeRows, setCustomUserAttributeRows] =
      React.useState<any>([]);
    const [peerUsers, setPeerUsers] = React.useState<any>(null);
    const [userAccessData, setUserAccessData] = React.useState<any>([]);
    const [userGroupData, setUserGroupData] = React.useState<any>([]);
    const [azureUserGroupData, setAzureUserGroupData] = React.useState<any>([]);
    const [watched, setWatched] = React.useState(false);
    const [critical, setCritical] = React.useState(false);
    const [whitelist, setWhitelist] = React.useState(false);
    const [serviceAc, setServiceAc] = React.useState(false);
    const [showLoader, setShowLoader] = React.useState(false);
    const [HeatMapData, setHeatMapData] = React.useState<any>([]);
    const [macAddress, setMacAddress] = React.useState("");
    const [editing, setEditing] = React.useState(false);
    const [summaryEditData, setSummaryEditData] = React.useState<any>({});
    const [savingSummary, setSavingSummary] = React.useState(false);
    const [attributeTab, setAttributeTab] = React.useState<string>("default");
    const [uid, setUid] = React.useState("");
    const [_userAttributes, set_UserAttributes] = React.useState<any>(null);

    const {
      data: userDetailsData,
      isLoading: userDetailsLoading,
      refetch: userDetailsRefetch,
      isFetching: userDetailsFetching,
      isError: userDetailsError,
    }: {
      data: any;
      isLoading: boolean;
      refetch: () => void;
      isFetching: boolean;
      isError: any;
    } = useQuery(
      ["getuserDetails", account, timeFrame],
      () =>
        getuserDetails({
          account: account,
          filterTime: timeFrame,
          is_super_admin: "False",
          is_external: is_external ? 1 : 0,
          plugin_id: pluginId,
          tenant_id: tenantId,
        }),
      { enabled: false },
    );

    const { data: pluginData, refetch: pluginDataRefetch } = useQuery(
      ["getPluginData"],
      () => getPluginFrontend(pluginDataParams.url, pluginDataParams.data),
      { enabled: false },
    );

    const { data: userEntitySessionsData, refetch: userEntitySessionsRefetch } =
      useQuery(
        ["userEntitySessions"],
        ({ signal }) => userEntitySessions(account, timeFrame, signal),
        { enabled: false },
      );

    const { data: pluginCategories, refetch: pluginCategoriesRefetch } =
      useQuery(
        ["getAvailablePluginCategories"],
        () => getAvailablePluginCategories("user_investigator"),
        { enabled: false },
      );

    const { data: peerData, refetch: peerRefetch } = useQuery(
      ["getPeerUsers"],
      ({ signal }) =>
        getPeerUsers(
          {
            username: account,
            source: _source || "",
            subSource: _pluginId,
            tenantId: _tenantId || "",
          },
          signal,
        ),
      { enabled: false },
    );

    // const { data: otherUserAttributes, isLoading: otherUserAttributesLoading } =
    //   useQuery(["getOtherUserAttributes"], ({ signal }) =>
    //     getOtherUserAttributes(
    //       { username: account, plugin_id: _pluginId },
    //       signal,
    //     ),
    //   );

    const { data: userdata, refetch: refetchUserGroupDetails } = useQuery(
      ["userGroupDetails", uid, _pluginId],
      ({ signal }) =>
        userGroupDetails({ uid: uid, plugin_id: _pluginId }, signal),
      {
        enabled:
          !(
            getFeatureValues(ALL_KEYS.USER_INVESTIGATOR_USER_GROUP)
              ?.data_source?.toLowerCase()
              .trim() === "redis"
          ) && !!uid,
      },
    );

    const {
      data: userDetailsAnomalies,
      refetch: refetchUserDetailsAnomalies,
      isLoading: userDetailsAnomaliesLoading,
      isRefetching: userDetailsAnomaliesRefetching,
    } = useQuery(
      ["userDetailsAnomalies"],
      ({ signal }) =>
        getUserDetailsAnomalies(
          {
            account: account,
            filterTime: timeFrame,
            source: _source || source,
            subSource: _pluginId || pluginId,
          },
          signal,
        ),
      { enabled: false },
    );

    React.useEffect(() => {
      if (userdata && Array.isArray(userdata)) {
        const formattedGroups = userdata.map((group) => ({
          groupname: group.group_name,
          source: group.source,
        }));
        setUserGroupData(formattedGroups);
      } else {
        setUserGroupData([]);
      }
    }, [userdata]);

    React.useEffect(() => {
      if (uid) {
        refetchUserGroupDetails();
      }
    }, [uid]);

    // React.useEffect(() => {
    const populateUserAttributes = (_otherUserAttributes: {
      system: any[];
      custom: any[];
    }) => {
      if (_otherUserAttributes) {
        const temp: any = [];

        if (_otherUserAttributes.system) {
          const systemattr = _otherUserAttributes.system;
          systemattr.forEach((element: any) => {
            let val = element.attribute_value;
            const type = element?.value_type || "string";
            if (isValidEpoch(val)) {
              val = EpochToDateTime(val);
            }
            if (type == "bool") {
              val = val === true || val === "true" ? "Yes" : "No";
            }
            temp.push({
              attribute: (
                <div className="capitalize">
                  {element.display_name ||
                    element.attribute_name.split("_").join(" ")}
                </div>
              ),
              value: val || "- - -",
            });
          });
        }

        if (_otherUserAttributes.custom) {
          const customattr = _otherUserAttributes.custom;
          customattr.forEach((element: any) => {
            let val = element.attribute_value;
            const type = element?.value_type || "string";
            if (isValidEpoch(val)) {
              val = EpochToDateTime(val);
            }
            if (type == "bool") {
              val = val === true || val === "true" ? "Yes" : "No";
            }
            temp.push({
              attribute: (
                <div className="capitalize">
                  {element.display_name ||
                    element.attribute_name.split("_").join(" ")}
                </div>
              ),
              value: val || "- - -",
            });
          });
        }
        setCustomUserAttributeRows(temp);
      }
    };
    // }, [otherUserAttributes]);

    function isValidEpoch(epoch: number | string): boolean {
      let num = Number(epoch);
      if (isNaN(num)) return false;
      if (num.toString().length < 10) return false;

      if (num.toString().length == 13) {
        num = num * 1000; // Convert seconds to milliseconds if needed
      }

      const date = num < 1e12 ? new Date(num * 1000) : new Date(num);
      return !isNaN(date.getTime());
    }

    React.useEffect(() => {
      if (account != "") {
        userDetailsRefetch();
        userEntitySessionsRefetch();
        pluginCategoriesRefetch();
        if (
          isFeatureAllowed(ALL_KEYS.USER_INVESTIGATOR_SUMMARYDATA) ||
          isFeatureAllowed(ALL_KEYS.USER_INVESTIGATOR_SERVICES)
        )
          userSourceDetailsRefetch();
      }
    }, [account]);

    React.useEffect(() => {
      if (account && account != "" && _pluginId && _pluginId != "") {
        peerRefetch();
        refetchUserDetailsAnomalies();
      }
    }, [_pluginId]);

    React.useEffect(() => {
      const temp: any = [];
      if (userEntitySessionsData) {
        if (
          "userSessions" in userEntitySessionsData &&
          userEntitySessionsData.userSessions.length > 0
        ) {
          userEntitySessionsData.userSessions.forEach((element: any) => {
            temp.push({
              firstActivity: element.first_login,
              lastActivity: element.last_login,
              ip: element.ip,
              hostname: element.host,
            });
          });
          setUserAccessData(temp);
        }
      }
    }, [userEntitySessionsData]);

    React.useEffect(() => {
      if (peerData) {
        setPeerUsers(peerData);

        //User Groups
        const temp: any = [];
        peerData.groups.forEach((element: any) => {
          temp.push({ groupname: element });
        });

        setUserGroupData(temp);
        //User Groups

        //Azure User Groups
        const _temp: any = [];
        peerData.azureGroups.forEach((element: any) => {
          _temp.push({ groupname: element });
        });

        setAzureUserGroupData(_temp);
        //Azure User Groups
      } else {
        setUserGroupData([]);
        setAzureUserGroupData([]);
      }
    }, [peerData]);

    React.useEffect(() => {
      if (pluginData && pluginDataParams) {
        const id = pluginDataParams.id;
        const element = document.getElementById(id);
        if (element) {
          // element.innerHTML = pluginData;
          ReactDOM.createRoot(element).render(
            <PluginEnv htmlContent={pluginData} />,
          );

          const elements = element.querySelectorAll(".nav-item");
          const content = element.querySelectorAll(".tab-content>.tab-pane");
          elements.forEach((el: any) => {
            el.addEventListener("click", () => {
              content.forEach((el: any) => {
                el.classList.remove("active");
                el.classList.remove("show");
              });

              elements.forEach((el: any) => {
                el.querySelector("a").classList.remove("active");
              });

              const href = el
                .querySelector("a")
                .getAttribute("aria-controls")
                .replace("#", "");
              const active = element?.querySelector("#" + href);

              active?.classList.add("active");
              active?.classList.add("show");

              el.querySelector("a").classList.add("active");
            });
          });
        }
      }
    }, [pluginData]);

    React.useEffect(() => {
      setExtraTabs(pluginCategories);
    }, [pluginCategories]);

    React.useEffect(() => {
      setShowNotExists(userDetailsError);
    }, [userDetailsError]);

    React.useEffect(() => {
      if (userDetailsData) {
        if (_pluginId == "") {
          if (!pluginId) {
            set_pluginId(userDetailsData.last_sub_source);
            set_source(userDetailsData.last_source);
            set_tenantId(userDetailsData.last_tenant_id);
            selectedSourceDetails(
              userDetailsData.last_sub_source,
              userDetailsData.last_tenant_id,
            );
          } else {
            set_pluginId(pluginId);
            const _temp = (userDetailsData.sources || {})[pluginId] || [];
            if (!tenantId) {
              if (_temp.length > 0) {
                set_tenantId(_temp[0].tenant_id);
                set_source(_temp[0].source);
                selectedSourceDetails(pluginId, _temp[0].tenant_id);
              }
            } else {
              set_source(
                _temp.find((e: any) => e.tenant_id == tenantId)?.source || "",
              );
              set_tenantId(tenantId);
              selectedSourceDetails(pluginId, tenantId);
            }
          }
        }

        //source dropdown
        const _temp: string[] = [];
        userDetailsData.sources &&
          Object.keys(userDetailsData.sources).forEach((key) => {
            if (userDetailsData.sources[key].length > 0) {
              userDetailsData.sources[key].forEach((sourceObj: any) => {
                const full_source =
                  key +
                  (sourceObj.tenant_id ? " (" + sourceObj.tenant_id + ")" : "");
                if (!_temp.includes(full_source)) {
                  _temp.push(full_source);
                }
              });
            }
          });
        _setSources(_temp);
        //source dropdown
      }
    }, [
      userDetailsData,
      // anomalyActionData
    ]);

    React.useEffect(() => {
      if (userDetailsAnomalies) {
        const newData: any = userDetailsAnomalies;
        setUserScore(newData.totalScore);
        const userTemp: any = [];
        if (newData.userAnomalies && Array.isArray(newData.userAnomalies)) {
          newData.userAnomalies.forEach((element: any) => {
            const exists = userTemp.find((e: any) => e.x == element.epochTime);
            if (exists) {
              element.y = exists.y + 1;
            } else {
              userTemp.push({
                x: element.epochTime,
                y: 1,
                anomalyId: element.attackID,
                id: element.id,
              });
            }
          });
        }
        setAnomalyChartData(userTemp);

        const temp: any = [];
        newData.userAnomalies.forEach((element: any) => {
          if (filterAnomalyId == 0 || filterAnomalyId == element.id) {
            temp.push({
              action: (
                <div className="flex items-center gap-1">
                  <Checkbox
                    checked={anomalyActionData
                      .map((e: any) => e.anomalyId)
                      .includes(element.id)}
                    onCheckedChange={(e: boolean) =>
                      setData(e, element.id, element.epochTime)
                    }
                  />
                  <AMLDropdownmenu
                    isModal
                    event_names={
                      "EventNames" in element ? element["EventNames"] : {}
                    }
                    anomalyId={element["id"]}
                    time_seen={element["epochTime"]}
                    anomaly_type={element["anomalyType"]}
                    data={{ anomaly_type: element["anomalyType"] }}
                    events={element["data"]["events"]}
                    filterTime={{
                      filterTime: timeFrame,
                      CustomFilter: "",
                      fromDate: "",
                      toDate: "",
                    }}
                  />
                </div>
              ),
              category: element.category,
              type: (
                <div>
                  <span className="pe-2">{element.type}</span>
                  <InfoIcon
                    size={14}
                    onClick={() => showAnomalyDetails(element.attackID)}
                    className="text-primary inline-block cursor-pointer"
                  />
                </div>
              ),
              description: element.desc,
              score:
                `<span class="bg-primary text-white px-2 py-1 rounded-sm">` +
                element.score +
                `</span>`,
              time: element.time,
            });
          }
        });
        setUserAnomalyData(temp);
      }
    }, [userDetailsAnomalies, anomalyActionData]);

    React.useEffect(() => {
      // if (userDetails) {
      if (userDetailsAnomalies) {
        setUserAnomalyData([]);
        const temp: any = [];
        userDetailsAnomalies.userAnomalies.forEach((element: any) => {
          // userDetails.userAnomalies.forEach((element: any) => {
          if (filterAnomalyId == 0 || filterAnomalyId == element.id) {
            temp.push({
              category: element.category,
              type: (
                <div>
                  <span className="pe-2">{element.type}</span>
                  <InfoIcon
                    size={14}
                    onClick={() => showAnomalyDetails(element.attackID)}
                    className="text-primary inline-block cursor-pointer"
                  />
                </div>
              ),
              description: element.desc,
              score:
                `<span class="bg-primary text-white px-2 py-1 rounded-sm">` +
                element.score +
                `</span>`,
              time: element.time,
            });
          }
        });
        setUserAnomalyData(temp);
      }
    }, [filterAnomalyId]);

    React.useEffect(() => {
      if (account != "") {
        userDetailsRefetch();
        userEntitySessionsRefetch();
        if (_pluginId && _pluginId) refetchUserDetailsAnomalies();
      }
    }, [timeFrame]);

    React.useEffect(() => {
      if (pluginDataParams) {
        pluginDataRefetch();
      }
    }, [pluginDataParams]);

    // const watchAttributeMutation = useMutation(changeUserAttribute, {
    const watchAttributeMutation = useMutation(updateUserAttribute, {
      onSuccess: (data) => {
        userDetailsRefetch();
        const _errorList: string[] = data?.error || [];
        let message = "Action saved successfully";
        if (_errorList.length > 0) {
          message = "An error occured!";
        }
        toast({
          title: "Success",
          description: message,
          variant: "success",
        });
        setSavingSummary(false);
        setSummaryEditData({});
      },
      onError: () => {
        toast({
          title: "Error",
          description: "An error occured!",
          variant: "destructive",
        });
        setSavingSummary(false);
      },
    });

    const deleteUserMutation = useMutation(deleteUser, {
      onSuccess: (res) => {
        if (res?.status) {
          toast({
            title: "Success",
            description: res?.message || "Deleted Asset Successfully",
            variant: "success",
          });
          if (onClose) {
            onClose();
          }
        } else {
          toast({
            title: "Error",
            description: res?.message || "An error occured!",
            variant: "destructive",
          });
        }
      },
      onError: () => {
        toast({
          title: "Error",
          description: "An error occured!",
          variant: "destructive",
        });
      },
    });

    const queryClient = useQueryClient();

    const watchActionMutation = useMutation(updateUserAttribute, {
      onSuccess: (data, variables) => {
        const _errorList: string[] = data?.error || [];
        let message = "Action saved successfully";
        let title = "Success";
        let _variant:
          | "default"
          | "destructive"
          | "info"
          | "warning"
          | "success"
          | null
          | undefined = "success";
        if (_errorList.length > 0) {
          message = _errorList.join(", ");
          title = "Error";
          _variant = "destructive";
        } else {
          if (variables.attributes[0].name == "is_critical") {
            message =
              variables.attributes[0].value == "1"
                ? "Marked as Critical"
                : "Removed from Critical";
          } else if (variables.attributes[0].name == "is_watched") {
            message =
              variables.attributes[0].value == "1"
                ? "Added to Watchlist"
                : "Removed to Watchlist";
            queryClient.invalidateQueries("watchedUserData");
          } else if (variables.attributes[0].name == "is_service_account") {
            message =
              variables.attributes[0].value == "1"
                ? "Added to Service Account"
                : "Removed from Service Account";
          } else if (variables.attributes[0].name == "whitelist") {
            message =
              variables.attributes[0].value == "1"
                ? "Added to Whitelist"
                : "Removed from Whitelist";
          } else if ("serviceAccount" in variables) {
            message =
              variables.serviceAccount == 1
                ? "Marked as Service Account"
                : "Removed from Service Account";
          }
        }
        toast({
          title: title,
          description: message,
          variant: _variant,
        });
        setShowLoader(false);
        userDetailsRefetch();
      },
      onError: () => {
        toast({
          title: "Error",
          description: "An error occured!",
          variant: "destructive",
        });
        setShowLoader(false);
      },
    });

    function setData(e: boolean, gid: number, time: number) {
      if (e) {
        setAnomalyActionData((prev: any) => [
          ...prev,
          { anomalyId: gid, time: time },
        ]);
      } else {
        setAnomalyActionData((prev: any) =>
          prev.filter((item: any) => item.anomalyId !== gid),
        );
      }
    }

    // function anomalyClicked(node: any) {
    //   if (node == null) {
    //     setFilterAnomalyId(0);
    //   } else {
    //     setFilterAnomalyId(node.id);
    //   }
    // }

    function showAnomalyDetails(AMLid: number) {
      setAnomalyId(AMLid);
      setanomalyDetailOpen(true);
    }

    const userAnomalyColumns = [
      { header: "Action", accessor: "action", type: "component" },
      { header: "Category", accessor: "category" },
      { header: "Type", accessor: "type", type: "component" },
      { header: "Description", accessor: "description" },
      { header: "Score", accessor: "score" },
      { header: "Time", accessor: "time" },
    ];

    const [userAnomalyData, setUserAnomalyData] = React.useState<any>([]);

    function timeFilterChanged(value: string) {
      setTimeFrame(value);
    }

    function changeAttribute(e: any, key: string) {
      setShowLoader(true);
      const _payload = {
        username: account,
        source: userDetails.source,
        subSource: userDetails.sub_source,
        tenantId: userDetails.tenant_id,
        attributes: [
          {
            name: key,
            value: e ? "1" : "0",
            isCustom: false,
            metadata: {
              time_seen: Math.floor(Date.now() / 1000),
              source: "user",
              sub_source: "UserInvestigator",
            }, // as discussed with shafraz adding metadata for the action
          },
        ],
      };
      watchActionMutation.mutate(_payload);
    }

    function getPluginData(
      pluginId: number,
      template: string,
      dataFunction: string,
      fields: Array<string>,
    ) {
      const url = "/plugin/" + pluginId + "/frontend";
      setPluginDataParams({
        url: url,
        data: {
          template: template,
          user: account,
          dataFunction: dataFunction,
          filterTime: timeFrame,
        },
        fields: fields,
        id: pluginId,
      });
    }

    const userAttributeCols = [
      { header: "Attribute", accessor: "attribute", type: "component" },
      { header: "Value", accessor: "value", type: "component" },
    ];

    const userEmail = userDetails ? userDetails.username : "";
    const defValue: any = {
      day: "1440",
      "3day": "4320",
      "7day": "10080",
      month: "43200",
      "2month": "86400",
    };
    const s360Url = encodeURI(
      `shadow360/?date={"endDate":"${defValue?.[timeFrame] || "1440"}","startDate":"${defValue?.[timeFrame] || "1440"}"}&plainText={"textFieldValue":"${userEmail}","textLogType":[],"textType":"username", "aId":""}&smartSearch=0&query={"textFieldValue":"${userEmail}","textLogType":"","textType":"username", "aId":""}`,
    );

    // function showEntityDetail(mac: string) {
    //   if (mac == "NA" || !mac) {
    //     toast({
    //       title: "Error",
    //       description: "MAC address not found",
    //       variant: "destructive",
    //     });
    //   } else {
    //     setMacAddress(mac);
    //   }
    // }

    const s360Url_notexists = encodeURI(
      `shadow360/?date={"endDate":"1440","startDate":"1440"}&plainText={"textFieldValue":"${account}","textLogType":"_all_logs","textType":"username", "aId":""}&smartSearch=0&query={"textFieldValue":"${account}","textLogType":"_all_logs","textType":"username", "aId":""}`,
    );

    function showFixDialog() {
      if (anomalyActionData.length > 0) {
        setShowAnomalyFix(true);
      } else {
        toast({
          title: "Error",
          description: "Please select atleast one anomaly to fix",
          variant: "destructive",
        });
      }
    }

    const selectionHandle = (s: boolean) => {
      if (s) {
        setAnomalyActionData(
          // userDetailsData.userAnomalies.map((e: any) => ({
          userDetailsAnomalies.userAnomalies.map((e: any) => ({
            anomalyId: e.id,
            time: e.epochTime,
          })),
        );
      } else {
        setAnomalyActionData([]);
      }
    };

    const fixAnomalyButton = (
      <div className="flex items-center">
        <div className="ml-4 flex items-center">
          <Checkbox id="terms" onCheckedChange={selectionHandle} />
          <Label
            htmlFor="terms"
            className="ml-2 text-sm font-medium leading-none"
          >
            Select/Unselect all
          </Label>
        </div>
        <Button className="ms-2" size="sm" onClick={showFixDialog}>
          Fix Selected Anomalies
        </Button>
      </div>
    );

    // let managername = userDetailsData ? userDetailsData.manager : "";
    let managername = _userAttributes ? _userAttributes.manager : "";
    if (!managername) {
      managername =
        peerUsers &&
        (peerUsers.manager.display_name || (
          <span className="opacity-50">_ _ _ _</span>
        ));
    }

    function editSummary(
      key: string,
      value: string,
      defaultValue: string,
      title: string,
    ) {
      setSummaryEditData({
        key: key,
        value: value,
        defaultValue: defaultValue,
        title: title,
      });
    }

    function saveUserData() {
      setSavingSummary(true);
      let newvalue = summaryEditData.newvalue;
      if (summaryEditData.key == "tags") {
        newvalue = newvalue.split(",").map((e: string) => e.trim());
      }

      const passdata: updateUserAttributeProps = {
        username: account,
        source: userDetails.source,
        subSource: userDetails.sub_source,
        tenantId: userDetails.tenant_id,
        attributes: [
          {
            name: summaryEditData.key,
            isCustom: false,
            value: newvalue,
          },
        ],
      };
      watchAttributeMutation.mutate(passdata);
    }

    let defaultTab = "anomalies";
    if (isFeatureAllowed(ALL_KEYS.USER_INVESTIGATOR_ANOMALIES) == false) {
      defaultTab = "usergroups";
    }

    const deleteUserAction = () => {
      const data = {
        username: account,
        source: userDetails.source,
        subSource: userDetails.sub_source,
        tenantId: userDetails.tenant_id || null,
      };
      deleteUserMutation.mutate(data);
      setDeleting(false);
    };

    // const deleteHandler = () => {
    //   // if (!mac) return;
    //   setDeleting(true);
    // };

    const selectedSourceDetails = (sub_source: string, _tenantId: string) => {
      if (
        userDetailsData &&
        userDetailsData.sources &&
        sub_source in userDetailsData.sources
      ) {
        let _sourceDetails =
          userDetailsData.sources[sub_source].find(
            (item: any) => item.tenant_id == _tenantId,
          ) || {};
        _sourceDetails = {
          ..._sourceDetails,
          username: userDetailsData.username,
        };
        setUserDetails(_sourceDetails);
        setUid(_sourceDetails.unique_id);

        setWatched(_sourceDetails.is_watched);
        setCritical(_sourceDetails.is_critical);
        setWhitelist(_sourceDetails.whitelist);
        setServiceAc(_sourceDetails.is_service_account);
        setSelectedSource(sub_source + " (" + _tenantId + ")");
        if (_sourceDetails.userExist == false) {
          setShowNotExists(true);
        }
        if (_sourceDetails.is_deleted) {
          setDeletedUserPopUp(true);
        }

        const temp = _sourceDetails.system_attr || [];

        let _user_attributes: any = {};
        temp.map((item: any) => {
          _user_attributes[item.attribute_name] = item.attribute_value;
        });
        _user_attributes = {
          ..._user_attributes,
          last_logon_time: _sourceDetails.last_seen,
          username: _sourceDetails.username,
          department: _sourceDetails.department,
          display_name: _sourceDetails.display_name,
        };
        set_UserAttributes(_user_attributes);
        //User Attributes

        if (_sourceDetails && "user_attributes" in _sourceDetails) {
          const tempDefault: any = [];
          const attrs = _sourceDetails.user_attributes;
          Object.keys(attrs).forEach((key: string) => {
            tempDefault.push({
              attribute: key.split("_").join(" "),
              value:
                typeof attrs[key] == "string"
                  ? attrs[key]
                  : JSON.stringify(attrs[key]),
            });
          });

          setDefaultUserAttributeRows(tempDefault);
        }
        //uncomment once keyerror resolved by api team
        populateUserAttributes({
          system: _sourceDetails.system_attr || [],
          custom: _sourceDetails.custom_attr || [],
        });
        //User Attributes

        //Heatmap data
        setHeatMapData(_sourceDetails.trainingData);
        //Heatmap data
      } else if (userDetailsData && is_external) {
        let _user_attributes: any = {};
        _user_attributes = {
          last_logon_time: userDetailsData.last_seen,
          username: userDetailsData.username,
        };
        set_UserAttributes(_user_attributes);
      }
    };

    const [selectedSource, setSelectedSource] = React.useState<string>("");
    const [_sources, _setSources] = React.useState<string[]>([]);
    const [open, setOpen] = React.useState(false);

    const onSourceChange = (value: string) => {
      setSelectedSource(value);
      const temp_source = value.split(" (")[0];
      const temp_tenantId = value.split(" (")[1]
        ? value.split(" (")[1].replace(")", "")
        : "";
      selectedSourceDetails(temp_source, temp_tenantId);
      set_pluginId(temp_source);
      set_tenantId(temp_tenantId);
      const _sourceDetails =
        userDetailsData?.sources[temp_source]?.find(
          (item: any) => item.tenant_id == temp_tenantId,
        ) || {};
      set_source(_sourceDetails?.source || "");
    };

    const sourceCustomFilter = (
      <Select
        onValueChange={(value) => onSourceChange(value)}
        value={selectedSource}
        defaultValue={selectedSource}
        onOpenChange={setOpen}
      >
        <TooltipProvider>
          <Tooltip defaultOpen={false} open={open ? false : undefined}>
            <TooltipTrigger asChild>
              <SelectTrigger className="w-[220px] rounded-none h-9 text-xs">
                <SelectValue placeholder="Select a source" />
              </SelectTrigger>
            </TooltipTrigger>
            <TooltipContent side="bottom">{selectedSource}</TooltipContent>
          </Tooltip>
        </TooltipProvider>
        <SelectContent>
          {_sources.map((item: string) => (
            <SelectItem key={item} value={item}>
              {item}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
    const summaryCustomOptions = (
      <div className="flex items-center gap-[1px]">
        {isFeatureAllowed(ALL_KEYS.USER_INVESTIGATOR_ST) && (
          <div className="m-2">{sourceCustomFilter}</div>
        )}
        {/* Hiding delete option now, will enable it later */}
        {/* {!isAdminUser ? null : (
          <div
            className={`p-2 border-background bg-secondary cursor-pointer`}
            onClick={deleteHandler}
          >
            <Trash size={14} />
          </div>
        )} */}
      </div>
    );

    const { data: installedPluginList } = useQuery(
      ["getInstalledPluginList"],
      ({ signal }) => getInstalledPluginList(signal),
    );

    const getPluginName = (plugin_id: string) => {
      const plugin = installedPluginList?.find(
        (item: any) => item.id === plugin_id,
      );
      if (plugin) {
        return plugin.name;
      } else {
        return "Default";
      }
    };

    const {
      data: userSourceDetails,
      isLoading: userSourceDataLoading,
      isFetching: userSourceDetailsFetching,
      refetch: userSourceDetailsRefetch,
    } = useQuery<UserProp>(
      ["userDetails", account],
      ({ signal }) =>
        getUserDeails(
          {
            username: account,
            user_id: undefined,
            is_external: is_external ? 1 : 0,
            plugin_id: _pluginId,
          },
          signal,
        ),
      {
        enabled: false,
      },
    );

    const [sourceDetails, setSourceDetails] = React.useState<UserProp | null>(
      null,
    );

    React.useEffect(() => {
      if (userSourceDetails) {
        setSourceDetails(userSourceDetails);
      } else {
        setSourceDetails(null);
      }
    }, [userSourceDetails]);

    const [activeTab, setActiveTab] = React.useState<string>(defaultTab);
    const handleTabChange = (tab: string) => {
      setActiveTab(tab);
    };

    const handleDialogClose = React.useCallback(() => {
      onClose?.();
    }, [onClose]);

    if (!hasUserInvestigatorAccess) {
      return (
        <Dialog open={openState} onOpenChange={handleDialogClose}>
          <DialogContent className="sm:max-w-[420px]">
            <DialogHeader>
              <DialogTitle>Access Denied</DialogTitle>
            </DialogHeader>
            <div className="py-4 text-sm text-center">
              You don&apos;t have permission to access this.
            </div>
            <DialogFooter>
              <Button variant="destructive" onClick={handleDialogClose}>
                Close
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      );
    }

    return (
      <>
        {deleting && (
          <ConfirmDialog
            text="Are you sure you want to delete this user?"
            confirmAction={deleteUserAction}
            rejectAction={() => setDeleting(false)}
            show={deleting}
            closeDialog={() => setDeleting(false)}
          />
        )}

        {Object.keys(summaryEditData).length > 0 && (
          <Dialog
            open={Object.keys(summaryEditData).length > 0}
            onOpenChange={() => setSummaryEditData({})}
          >
            <DialogContent className="sm:max-w-[425px]">
              <DialogHeader>
                <DialogTitle>{summaryEditData.title}</DialogTitle>
              </DialogHeader>
              <div className="w-full">
                <div>
                  <Input
                    onChange={(e: any) => {
                      summaryEditData["newvalue"] = e.target.value;
                    }}
                    type="text"
                    placeholder={summaryEditData.title + "..."}
                    defaultValue={
                      summaryEditData.defaultValue || summaryEditData.name
                    }
                  />
                </div>
              </div>
              <DialogFooter>
                <Button onClick={saveUserData} type="submit">
                  <span>Save</span>
                  <LoaderIcon
                    size={14}
                    className={
                      "ms-2 animate-spin " + (savingSummary ? "" : "hidden")
                    }
                  />
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        )}

        {showAnomalyFix && (
          <AnomalyFixedDialog
            action="fixanomaly"
            anomalyType="User"
            show={true}
            onClose={() => setShowAnomalyFix(false)}
            anomalyData={anomalyActionData}
          />
        )}
        {macAddress ? (
          <AssetEntityInspectorContent
            open={true}
            onClose={() => setMacAddress("")}
            mac={macAddress}
            filter_time={timeFrame}
          />
        ) : (
          ""
        )}
        <AnomalyDetail
          openState={anomalyDetailOpen}
          onClose={() => setanomalyDetailOpen(false)}
          anomalyId={anomalyId}
        />
        <Dialog
          open={userAttributeDialog}
          onOpenChange={() => setUserAttributeDialog(false)}
        >
          <DialogContent className="sm:max-w-[45vw]">
            <DialogHeader>
              <DialogTitle>User Attributes</DialogTitle>
            </DialogHeader>
            <div className="max-h-[80vh] w-full overflow-y-auto">
              <DataTable
                cols={userAttributeCols}
                data={
                  attributeTab == "default"
                    ? userDefaultAttributeRows
                    : userCustomAttributeRows
                }
                colFilter={false}
                countPerPageSelection={true}
                pagination={true}
                totalCount={
                  attributeTab == "default"
                    ? userDefaultAttributeRows.length
                    : userCustomAttributeRows.length
                }
              />
            </div>
          </DialogContent>
        </Dialog>

        <Dialog
          open={openState && hasUserInvestigatorAccess}
          onOpenChange={handleDialogClose}
        >
          <DialogContent
            style={{
              width: getFeatureValues(ALL_KEYS.USER_INVESTIGATOR_ACCESS).width,
              marginLeft: getFeatureValues(ALL_KEYS.USER_INVESTIGATOR_ACCESS)
                .marginLeft,
            }}
            className={`overflow-y-scroll p-2 transform-none max-h-[90vh] -mt-[45vh] max-w-none`}
          >
            <DialogLoader
              show={userDetailsLoading || userDetailsFetching || showLoader}
            />
            <DialogHeader autoFocus={false} className="relative mt-4">
              <div className="w-full grid grid-cols-10">
                <div className="col-span-5 pt-1">
                  <DialogTitle>User Investigator</DialogTitle>
                </div>
                <div className="col-span-5 text-end flex justify-end items-center">
                  {getFeatureValues(ALL_KEYS.USER_INVESTIGATOR_TIMEFRAME)
                    .location == "top" && (
                    <TimeFilter
                      customClass="mr-2"
                      defaultValue={filter_time}
                      onChangeEvent={timeFilterChanged}
                    />
                  )}
                  <div className="me-10">
                    {!isFeatureAllowed(ALL_KEYS.USER_INVESTIGATOR_ST) &&
                      sourceCustomFilter}
                  </div>
                </div>
              </div>
            </DialogHeader>
            {isFeatureAllowed(ALL_KEYS.SHADOW_GPT_FLOAT_USER_INVESTOGATOR) && (
              <ShadowGPTFloat
                data={{ page: "__user_investigator__" }}
                displayIn="dialog"
              />
            )}
            <div className="w-full grid grid-cols-12 gap-2 relative">
              {/* user deleted */}
              {deletedUserPopUp && (
                <div className="z-modal-level-3 fixed top-0 left-0 w-full h-full bg-black/80">
                  <div className="fixed top-2/4 left-2/4 -translate-x-2/4 -translate-y-2/4 w-96 bg-background p-4 rounded-md shadow-xl">
                    <div className="w-full text-2xl text-center my-6">
                      This user no longer exists in “{_tenantId}”. Information
                      associated with this user will no longer be updated!
                    </div>
                    <DialogFooter>
                      <Button
                        variant="destructive"
                        onClick={() => {
                          setDeletedUserPopUp(false);
                          // if (onClose) {
                          //   onClose();
                          // }
                        }}
                      >
                        Close
                      </Button>
                    </DialogFooter>
                  </div>
                </div>
              )}
              {/* user deleted */}

              {/* User does not exists */}
              {showNotExists && (
                <div className="z-modal-level-3 fixed top-0 left-0 w-full h-full bg-black/80">
                  <div className="fixed top-2/4 left-2/4 -translate-x-2/4 -translate-y-2/4 w-96 bg-background p-4 rounded-md shadow-xl">
                    <div className="w-full text-2xl text-center my-6">
                      The user is not part of Linkshadow Environment
                    </div>
                    <DialogFooter>
                      <Button
                        variant="default"
                        onClick={() => window.open(s360Url_notexists, "_self")}
                      >
                        Search in Shadow360
                      </Button>
                      <Button
                        variant="destructive"
                        onClick={() => {
                          setShowNotExists(false);
                          if (onClose) {
                            onClose();
                          }
                        }}
                      >
                        Close
                      </Button>
                    </DialogFooter>
                  </div>
                </div>
              )}
              {/* User does not exists */}

              {isFeatureAllowed(ALL_KEYS.USER_INVESTIGATOR_SUMMARY) && (
                <div
                  className={`${getFeatureValues(ALL_KEYS.USER_INVESTIGATOR_SUMMARY).class || "col-span-4"}`}
                >
                  {!is_external ? (
                    <CustomWidget
                      title={
                        getFeatureValues(ALL_KEYS.USER_INVESTIGATOR_SUMMARY)
                          .label || "Summary"
                      }
                      className="h-96"
                      onEditClick={() => setEditing((prev: boolean) => !prev)}
                      customOptions={summaryCustomOptions}
                      // customOptions={
                      //   !isAdminUser ? null : (
                      //     <div
                      //       className={`p-2 border-background bg-secondary cursor-pointer`}
                      //       onClick={deleteHandler}
                      //     >
                      //       <Trash size={14} />
                      //     </div>
                      //   )
                      // }
                      info="Provides summary details of some important information related to that particular user"
                    >
                      <div className="w-full grid-cols-12 gap-2 my-4 grid">
                        <div className="col-span-5 border-r align-middle relative">
                          <div className="absolute top-[50%] -translate-y-[50%] w-full">
                            <img
                              src={
                                _userAttributes &&
                                "thumbnailPhoto" in _userAttributes &&
                                _userAttributes.thumbnailPhoto != ""
                                  ? "data:image/jpeg;base64," +
                                    _userAttributes.thumbnailPhoto
                                  : process.env.STATIC_PATH + "/images/user.jpg"
                              }
                              className="w-16 h-16 object-cover rounded-full inline-block"
                            />
                            <div className="inline-block ms-4 bg-primary text-white text-sm font-bold px-4 rounded-full border border-white">
                              {userScore}
                            </div>
                            <div className="mt-4 text-xs flex">
                              <UserIcon className="me-2" size={12} />
                              <div className="flex-1">
                                {_userAttributes
                                  ? _userAttributes.display_name
                                  : ""}
                              </div>
                            </div>
                            <div className="mt-2 text-xs flex">
                              <BriefcaseIcon className="me-2" size={12} />
                              <div className="flex-1">
                                {_userAttributes?.job_title || "_ _ _ _"}
                              </div>
                            </div>
                            <div className="mt-2 text-xs flex">
                              <PhoneIcon className="me-2" size={12} />
                              <div className="flex-1">
                                {_userAttributes &&
                                _userAttributes.mobile_number &&
                                _userAttributes.mobile_number.length > 4
                                  ? _userAttributes.mobile_number
                                  : "_ _ _ _"}
                              </div>
                            </div>
                            <div className="mt-2 text-xs flex">
                              <MailIcon className="me-2" size={12} />
                              <div className="overflow-hidden whitespace-nowrap text-ellipsis flex-1">
                                {_userAttributes
                                  ? _userAttributes.username
                                    ? _userAttributes.username
                                    : "_ _ _ _"
                                  : "_ _ _ _"}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-span-7 px-4">
                          <div className="text-sm font-bold mb-4">
                            User Details
                          </div>
                          <div>
                            {userDetailsLoading || userDetailsFetching ? (
                              <TableLoader />
                            ) : (
                              <div className="grid grid-cols-8 gap-2 text-xs">
                                {account && (
                                  <>
                                    <div className="col-span-3">Username</div>
                                    <div className="col-span-5">{account}</div>
                                  </>
                                )}

                                <div className="col-span-3">Last Seen</div>
                                <div className="col-span-5">
                                  {_userAttributes ? (
                                    _userAttributes.last_logon_time ? (
                                      EpochToDateTime(
                                        _userAttributes.last_logon_time,
                                      )
                                    ) : (
                                      <span className="opacity-50">
                                        _ _ _ _
                                      </span>
                                    )
                                  ) : (
                                    <span className="opacity-50">_ _ _ _</span>
                                  )}
                                </div>

                                <div className="col-span-3">Department</div>
                                <div
                                  className={`col-span-5 ${editing ? "text-blue-500 cursor-pointer" : ""}`}
                                  onClick={() =>
                                    editSummary(
                                      "department",
                                      _userAttributes.department || "",
                                      _userAttributes.department || "",
                                      "Department",
                                    )
                                  }
                                >
                                  {_userAttributes ? (
                                    _userAttributes.department ? (
                                      _userAttributes.department
                                    ) : (
                                      <span className="opacity-50">
                                        {editing ? "Not Available" : "_ _ _ _"}
                                      </span>
                                    )
                                  ) : (
                                    <span className="opacity-50">
                                      {editing ? "Not Available" : "_ _ _ _"}
                                    </span>
                                  )}
                                </div>

                                <div className="col-span-3">Manager</div>
                                <div className="col-span-5">{managername}</div>

                                <div className="col-span-3">Tags</div>
                                <div
                                  className={`col-span-5 ${editing ? "text-blue-500 cursor-pointer" : ""}`}
                                  onClick={() =>
                                    editSummary(
                                      "tags",
                                      _userAttributes.tags || "",
                                      _userAttributes.tags
                                        ? JSON.parse(_userAttributes.tags).join(
                                            ", ",
                                          )
                                        : "",
                                      "Tags",
                                    )
                                  }
                                >
                                  {_userAttributes && _userAttributes.tags ? (
                                    JSON.parse(_userAttributes.tags)?.length >
                                    0 ? (
                                      JSON.parse(_userAttributes.tags).join(
                                        ", ",
                                      )
                                    ) : (
                                      <span className="opacity-50">
                                        {editing ? "Not Available" : "_ _ _ _"}
                                      </span>
                                    )
                                  ) : (
                                    <span className="opacity-50">
                                      {editing ? "Not Available" : "_ _ _ _"}
                                    </span>
                                  )}
                                </div>

                                <div className="col-span-3">Comments</div>
                                <div
                                  className={`col-span-5 ${editing ? "text-blue-500 cursor-pointer" : ""}`}
                                  onClick={() =>
                                    editSummary(
                                      "comment",
                                      _userAttributes.comment || "",
                                      _userAttributes.comment || "",
                                      "Comments",
                                    )
                                  }
                                >
                                  {_userAttributes &&
                                  "comment" in _userAttributes ? (
                                    _userAttributes.comment ? (
                                      _userAttributes.comment
                                    ) : (
                                      <span className="opacity-50">
                                        {editing ? "Not Available" : "_ _ _ _"}
                                      </span>
                                    )
                                  ) : (
                                    <span className="opacity-50">
                                      {editing ? "Not Available" : "_ _ _ _"}
                                    </span>
                                  )}
                                </div>

                                <div className="col-span-3">City</div>
                                <div className="col-span-5">
                                  {_userAttributes &&
                                  "city" in _userAttributes ? (
                                    _userAttributes.city ? (
                                      _userAttributes.city
                                    ) : (
                                      <span className="opacity-50">
                                        _ _ _ _
                                      </span>
                                    )
                                  ) : (
                                    <span className="opacity-50">_ _ _ _</span>
                                  )}
                                </div>

                                <div className="col-span-3">Country</div>
                                <div className="col-span-5">
                                  {_userAttributes &&
                                  "country" in _userAttributes ? (
                                    _userAttributes.country ? (
                                      _userAttributes.country
                                    ) : (
                                      <span className="opacity-50">
                                        _ _ _ _
                                      </span>
                                    )
                                  ) : (
                                    <span className="opacity-50">_ _ _ _</span>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </CustomWidget>
                  ) : (
                    <CustomWidget
                      title={
                        getFeatureValues(ALL_KEYS.USER_INVESTIGATOR_SUMMARY)
                          .label || "Summary"
                      }
                      className={`h-96 ${getFeatureValues(ALL_KEYS.USER_INVESTIGATOR_SUMMARY).class || ""}`}
                      info="Provides summary details of some important information related to that particular user."
                    >
                      <div className="w-full h-full">
                        <div className="border-r p-4">
                          <img
                            src={process.env.STATIC_PATH + "/images/user.jpg"}
                            className="w-16 h-16 object-cover rounded-full inline-block"
                          />
                          <div className="mt-4 text-xs grid grid-cols-12 items-center gap-1">
                            <div className="col-span-3 ">Username:</div>
                            <div className="col-span-9">
                              {_userAttributes ? (
                                _userAttributes.username
                              ) : (
                                <span className="opacity-50">_ _ _ _</span>
                              )}
                            </div>
                          </div>
                          <div className="mt-2 text-xs grid grid-cols-12 items-center gap-1">
                            <div className="col-span-3 ">Last Seen:</div>
                            <div className="col-span-9">
                              {_userAttributes ? (
                                _userAttributes.last_logon_time ? (
                                  EpochToDateTime(
                                    _userAttributes.last_logon_time,
                                  )
                                ) : (
                                  <span className="opacity-50">_ _ _ _</span>
                                )
                              ) : (
                                <span className="opacity-50">_ _ _ _</span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </CustomWidget>
                  )}
                </div>
              )}
              {isFeatureAllowed(ALL_KEYS.USER_INVESTIGATOR_HEATMAP) && (
                <div
                  className={`${isFeatureAllowed(ALL_KEYS.USER_INVESTIGATOR_SMALL) ? "col-span-5" : "col-span-4"}`}
                >
                  <CustomWidget
                    title="Activity Heatmap"
                    className="h-full"
                    info="Activity heatmap showcasing the behavior pattern of this user in your environment by the number of authenticated login captures and email count from Office360 if integrated"
                  >
                    <div id="heatmap" className="mt-4 h-64">
                      <HeatMap
                        parentid="heatmap"
                        data={HeatMapData}
                        labels={["Login Count", "Email Count"]}
                      />
                    </div>
                  </CustomWidget>
                </div>
              )}
              {isFeatureAllowed(ALL_KEYS.USER_INVESTIGATOR_SOURCE) && (
                <CustomWidget
                  className="col-span-2"
                  title="Sources"
                  info="Sources of data for this user"
                >
                  <Sources plugin_id={_pluginId} source={source || ""} />
                </CustomWidget>
              )}
              {isFeatureAllowed(ALL_KEYS.USER_INVESTIGATOR_SUMMARYDATA) && (
                <CustomWidget
                  className={`col-span-5 h-96 overflow-y-auto ${getFeatureValues(ALL_KEYS.USER_INVESTIGATOR_SUMMARYDATA).class || ""}`}
                  title="Summary"
                  info="Source Summary Data"
                >
                  <Summary
                    loading={userSourceDataLoading || userSourceDetailsFetching}
                    userDetails={sourceDetails as UserProp}
                  />
                </CustomWidget>
              )}
              {isFeatureAllowed(ALL_KEYS.USER_INVESTIGATOR_SERVICES) && (
                <CustomWidget
                  className={`${is_external ? "col-span-6" : "col-span-4"} relative h-96 overflow-y-auto`}
                  title="Services"
                  info="Services related to this user"
                >
                  <Services
                    account={account}
                    is_external={is_external}
                    loading={userSourceDataLoading || userSourceDetailsFetching}
                    userDetails={sourceDetails as UserProp}
                  />
                </CustomWidget>
              )}
              {isFeatureAllowed(ALL_KEYS.USER_INVESTIGATOR_SENSITIVE_INFO) && (
                <div className={`${is_external ? "col-span-6" : "col-span-4"}`}>
                  <SensitivityDataByCategory
                    username={account}
                    is_external={is_external}
                  />
                </div>
              )}
              {isFeatureAllowed(ALL_KEYS.USER_INVESTIGATOR_ACTIONS) && (
                <div
                  className={`${getFeatureValues(ALL_KEYS.USER_INVESTIGATOR_ACTIONS).class || "col-span-2"}`}
                >
                  <CustomWidget
                    title="Actions"
                    info="Actions that can be taken on this user on LinkShadow's console"
                    className="h-96"
                  >
                    <div className="flex flex-col gap-2">
                      <div className="flex items-center space-x-2">
                        <Switch
                          id="critical"
                          checked={critical}
                          onCheckedChange={(e: boolean) => {
                            setCritical(e);
                            changeAttribute(e, "is_critical");
                          }}
                          className="shadow-md border border-border-secondary"
                        />
                        <Label htmlFor="critical" className="ps-3">
                          Critical
                        </Label>
                      </div>
                      <div className="flex items-center space-x-2">
                        <Switch
                          id="watchlist"
                          checked={watched}
                          onCheckedChange={(e: boolean) => {
                            setWatched(e);
                            changeAttribute(e, "is_watched");
                          }}
                          className="shadow-md border border-border-secondary"
                        />
                        <Label htmlFor="watchlist" className="ps-3">
                          Watchlist
                        </Label>
                      </div>
                      <div className="flex items-center space-x-2">
                        <Switch
                          id="whitelist"
                          checked={whitelist}
                          onCheckedChange={(e: boolean) => {
                            setWhitelist(e);
                            changeAttribute(e, "whitelist");
                          }}
                          className="shadow-md border border-border-secondary"
                        />
                        <Label htmlFor="whitelist" className="ps-3">
                          Whitelist
                        </Label>
                      </div>
                      <div className="flex items-center space-x-2">
                        <Switch
                          id="service"
                          checked={serviceAc}
                          onCheckedChange={(e: boolean) => {
                            setServiceAc(e);
                            changeAttribute(e, "is_service_account");
                          }}
                          className="shadow-md border border-border-secondary"
                        />
                        <Label htmlFor="service" className="ps-3">
                          Service Account
                        </Label>
                      </div>
                    </div>
                    <div className="cursor-pointer pt-4">
                      <div className="text-center w-full border-t relative h-16 pt-4">
                        <a
                          href={s360Url}
                          data-ip={"'" + userEmail + "'"}
                          target="_blank"
                          data-mac=""
                          data-anomalytype="user"
                          rel="noreferrer"
                        >
                          <img
                            src={
                              process.env.STATIC_PATH +
                              (theme == "dark"
                                ? "/images/menu-item-shadow360.png"
                                : "/images/menu-item-shadow360-black.png")
                            }
                            className="absolute left-[50%] -translate-x-[50%] w-10 h-10"
                          />
                        </a>
                      </div>
                      <div className="text-xs text-center mt-1">Shadow 360</div>
                    </div>
                  </CustomWidget>
                </div>
              )}
              {isFeatureAllowed(ALL_KEYS.USER_INVESTIGATOR_HOSTS) && (
                <div className="col-span-2">
                  <CustomWidget
                    title="Hosts"
                    info="List of hosts this user has access to"
                    className="h-full"
                  >
                    <div className="my-4 relative h-60 overflow-y-auto">
                      {!userDetails || userDetails.hosts.length == 0 ? (
                        <div className="absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]">
                          <NoData />
                        </div>
                      ) : (
                        <div>
                          {userDetails
                            ? userDetails.hosts.map(
                                (host: any, index: number) => (
                                  <div key={index} className="mb-4">
                                    <TooltipProvider delayDuration={0}>
                                      <Tooltip>
                                        <TooltipTrigger asChild>
                                          <div
                                            className="text-sm font-bold inline-block"
                                            onClick={() => {
                                              if (
                                                isFeatureAllowed(
                                                  ALL_KEYS.ASSET_ENTITY_INSPECTOR,
                                                )
                                              ) {
                                                setMacAddress(host.mac);
                                              }
                                            }}
                                          >
                                            <ComputerIcon className="border-white !w-10 !h-10 border p-1 rounded-md bg-primary text-white inline-block me-4" />
                                            <span>{host.host}</span>
                                          </div>
                                        </TooltipTrigger>
                                        <TooltipContent>
                                          {host.mac &&
                                          host.mac != "" &&
                                          host.mac != "NA" ? (
                                            <div className="text-xs">
                                              mac :{" "}
                                              <span className="text-primary">
                                                {host.mac}
                                              </span>
                                            </div>
                                          ) : (
                                            "MAC address not found. Machine out of network"
                                          )}
                                        </TooltipContent>
                                      </Tooltip>
                                    </TooltipProvider>
                                  </div>
                                ),
                              )
                            : ""}
                        </div>
                      )}
                    </div>
                  </CustomWidget>
                </div>
              )}
              {isFeatureAllowed(ALL_KEYS.USER_INVESTIGATOR_ATTRIBUTES) &&
                !is_external && (
                  <div
                    className={`${getFeatureValues(ALL_KEYS.USER_INVESTIGATOR_ATTRIBUTES).class || "col-span-4"}`}
                  >
                    <CustomWidget
                      title="User Attributes"
                      onDetailClick={() => setUserAttributeDialog(true)}
                      detailButton={true}
                      className="relative h-96"
                      info="List of user attributes collected on this user from the AD"
                      customOptions={
                        isFeatureAllowed(ALL_KEYS.USER_INVESTIGATOR_ST) && (
                          <div className="m-2">{sourceCustomFilter}</div>
                        )
                      }
                    >
                      <Tabs
                        defaultValue="default"
                        onValueChange={(tabname: string) =>
                          setAttributeTab(tabname)
                        }
                      >
                        <TabsList>
                          <TabsTrigger value="default" className="text-xs">
                            {getPluginName(_pluginId)}
                          </TabsTrigger>
                          <TabsTrigger value="custom" className="text-xs">
                            Other
                          </TabsTrigger>
                        </TabsList>
                        <TabsContent value="default" className="text-xs">
                          <div className="h-60 overflow-y-auto">
                            {userDetailsLoading || userDetailsFetching ? (
                              <TableLoader />
                            ) : userDefaultAttributeRows.length == 0 ? (
                              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                                <NoData />
                              </div>
                            ) : (
                              <table className="text-xs border-spacing-1 w-full border-collapse">
                                <tbody>
                                  {userDefaultAttributeRows
                                    ?.slice(
                                      0,
                                      getFeatureValues(
                                        ALL_KEYS.USER_INVESTIGATOR_ATTRIBUTES,
                                      ).maxCount || 10,
                                    )
                                    .map((row: any, index: number) => (
                                      <tr key={index} className="border-b">
                                        <td className="w-[50%] py-2.5">
                                          {row.attribute}
                                        </td>
                                        <td>{row.value}</td>
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            )}
                          </div>
                        </TabsContent>
                        <TabsContent value="custom" className="text-xs">
                          <div className="h-60 overflow-y-auto">
                            {/* {otherUserAttributesLoading ? ( */}
                            {userDetailsLoading || userDetailsFetching ? (
                              <TableLoader />
                            ) : userCustomAttributeRows.length == 0 ? (
                              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                                <NoData />
                              </div>
                            ) : (
                              <table className="text-xs border-spacing-1 w-full border-collapse">
                                {userCustomAttributeRows
                                  .slice(
                                    0,
                                    getFeatureValues(
                                      ALL_KEYS.USER_INVESTIGATOR_ATTRIBUTES,
                                    ).maxCount || 10,
                                  )
                                  .map((item: any, index: number) => (
                                    <tr key={index} className="border-b">
                                      <td className="w-[50%] py-2.5">
                                        {item.attribute}
                                      </td>
                                      <td>{item.value}</td>
                                    </tr>
                                  ))}
                              </table>
                            )}
                          </div>
                        </TabsContent>
                      </Tabs>
                    </CustomWidget>
                  </div>
                )}

              {/* Tabs section */}
              <div
                className={`${getFeatureValues(ALL_KEYS.USER_INVESTIGATOR_TABS).class || "col-span-8"}`}
              >
                <div className="flex justify-end">
                  {getFeatureValues(ALL_KEYS.USER_INVESTIGATOR_TIMEFRAME)
                    .location == "anomaly" &&
                    activeTab &&
                    activeTab == "anomalies" && (
                      <TimeFilter
                        customClass="mr-2"
                        defaultValue={filter_time}
                        onChangeEvent={timeFilterChanged}
                      />
                    )}

                  {!is_external &&
                    isFeatureAllowed(ALL_KEYS.USER_INVESTIGATOR_ST) && (
                      <div className="flex justify-end mb-2">
                        {sourceCustomFilter}
                      </div>
                    )}
                </div>
                <Tabs
                  defaultValue={defaultTab}
                  className="w-[100%]"
                  onValueChange={(tabname: string) => handleTabChange(tabname)}
                >
                  <TabsList className="w-full overflow-x-auto whitespace-nowrap h-[100%] overflow-y-hidden inline-block">
                    {isFeatureAllowed(ALL_KEYS.USER_INVESTIGATOR_ANOMALIES) && (
                      <TabsTrigger value="anomalies" className="text-xs px-4">
                        <span>Anomalies</span>
                        <span className="px-2 py-px bg-primary text-white text-xs font-bold ms-2 rounded-md">
                          {userAnomalyData.length}
                        </span>
                      </TabsTrigger>
                    )}
                    {isFeatureAllowed(ALL_KEYS.USER_INVESTIGATOR_USER_ACCESS) &&
                      !is_external && (
                        <TabsTrigger
                          value="useraccess"
                          className="text-xs px-4"
                        >
                          <span>User Access</span>
                          <span className="px-2 py-px bg-primary text-white text-xs font-bold ms-2 rounded-md">
                            {userAccessData.length}
                          </span>
                        </TabsTrigger>
                      )}
                    {isFeatureAllowed(ALL_KEYS.USER_INVESTIGATOR_PEER_USERS) &&
                      !is_external && (
                        <TabsTrigger value="peerusers" className="text-xs px-4">
                          <span>Peer Users</span>
                          <span className="px-2 py-px bg-primary text-white text-xs font-bold ms-2 rounded-md">
                            {peerUsers ? peerUsers.peerUsers.length : 0}
                          </span>
                        </TabsTrigger>
                      )}
                    {isFeatureAllowed(ALL_KEYS.USER_INVESTIGATOR_USER_GROUP) &&
                      !is_external && (
                        <TabsTrigger
                          value="usergroups"
                          className="text-xs px-4"
                        >
                          <span> User Groups</span>
                          <span className="px-2 py-px bg-primary text-white text-xs font-bold ms-2 rounded-md">
                            {userGroupData.length}
                          </span>
                        </TabsTrigger>
                      )}

                    {!is_external && peerData && peerData.azureStatus == 1 ? (
                      getFeatureValues(
                        ALL_KEYS.USER_INVESTIGATOR_AZURE_USER_GROUP,
                      ).data_source == "redis" ? (
                        <TabsTrigger
                          value="azureusergroups"
                          className="text-xs px-4"
                        >
                          <span>Azure User Groups</span>
                          <span className="px-2 py-px bg-primary text-white text-xs font-bold ms-2 rounded-md">
                            {azureUserGroupData.length}
                          </span>
                        </TabsTrigger>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}

                    {extraTabs
                      ? extraTabs.map((tab: any, index: number) => (
                          <TabsTrigger
                            value={tab.id}
                            key={index}
                            onClick={() =>
                              getPluginData(
                                tab.id,
                                tab.details.template,
                                tab.details.data_function,
                                tab.details.displayField,
                              )
                            }
                            className="text-xs px-4"
                          >
                            {tab.name}
                          </TabsTrigger>
                        ))
                      : ""}
                  </TabsList>

                  {isFeatureAllowed(ALL_KEYS.USER_INVESTIGATOR_ANOMALIES) && (
                    <TabsContent value="anomalies" className="mt-0.5">
                      <div className="w-full grid grid-cols-6">
                        <div className="col-span-4 pe-2">
                          <CustomWidget
                            title="Anomalies"
                            info="Users anomalies recorded for this particular user"
                            className="h-full"
                          >
                            <div
                              id="anomalychart"
                              className="w-full h-full min-h-40 relative"
                            >
                              {anomalyChartData.length == 0 ? (
                                <div className="absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]">
                                  <NoData />
                                </div>
                              ) : (
                                <LineChart
                                  data={[anomalyChartData]}
                                  parentid="anomalychart"
                                  config={{
                                    timeSeries: true,
                                    showPoints: true,
                                  }}
                                />
                              )}
                            </div>
                          </CustomWidget>
                        </div>
                        <div className="col-span-2">
                          <CustomWidget
                            title="Category"
                            info="User anomalies for this user, mapped to the different categories."
                            className="h-full w-full relative"
                          >
                            {userDetailsAnomaliesLoading ? (
                              <TableLoader colCount={2} />
                            ) : (
                              <div className="w-full text-xs py-4 relative h-full">
                                {userDetailsAnomalies &&
                                userDetailsAnomalies?.attackStages ? (
                                  Object.keys(
                                    userDetailsAnomalies.attackStages,
                                  ).map((key: string) => (
                                    <div
                                      className="w-full grid grid-cols-2 mb-4"
                                      key={key}
                                    >
                                      <div className="col-span-1">{key}</div>
                                      <div className="col-span-1 font-bold text-primary text-center text-sm">
                                        {userDetailsAnomalies.attackStages[key]
                                          ? userDetailsAnomalies.attackStages[
                                              key
                                            ]
                                          : 0}
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <div className="absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]">
                                    <NoData />
                                  </div>
                                )}
                              </div>
                            )}
                          </CustomWidget>
                        </div>
                        <div className="col-span-6">
                          <div className="max-h-60 relative my-2">
                            <DataTable
                              sort={false}
                              loading={
                                userDetailsAnomaliesLoading ||
                                userDetailsAnomaliesRefetching
                              }
                              className="bg-primary-background p-2"
                              cols={userAnomalyColumns}
                              data={userAnomalyData}
                              countPerPageSelection={true}
                              colFilter={false}
                              extraOptions={fixAnomalyButton}
                              totalCount={userAnomalyData.length}
                            />
                          </div>
                        </div>
                      </div>
                    </TabsContent>
                  )}
                  {isFeatureAllowed(ALL_KEYS.USER_INVESTIGATOR_USER_ACCESS) && (
                    <TabsContent value="useraccess" className="mt-0.5">
                      <CustomWidget info="List of hosts this user has had access to">
                        <div className="min-h-60 overflow-y-auto relative">
                          {userDetailsLoading || userDetailsFetching ? (
                            <TableLoader />
                          ) : userAccessData.length == 0 ? (
                            <div className="absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]">
                              <NoData />
                            </div>
                          ) : (
                            <DataTable
                              cols={userAccessHeader}
                              data={userAccessData}
                              totalCount={userAccessData.length}
                              pagination={true}
                              colFilter={false}
                              countPerPageSelection={true}
                            />
                          )}
                        </div>
                      </CustomWidget>
                    </TabsContent>
                  )}
                  {isFeatureAllowed(ALL_KEYS.USER_INVESTIGATOR_PEER_USERS) && (
                    <TabsContent value="peerusers" className="mt-0.5">
                      <CustomWidget info="Peer Users">
                        <div className="min-h-60 relative">
                          {!peerUsers || peerUsers.peerUsers.length == 0 ? (
                            <div className="absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]">
                              <NoData />
                            </div>
                          ) : (
                            <div className="w-full grid grid-cols-4 gap-4 max-h-[50vh] overflow-y-scroll">
                              {peerUsers
                                ? peerUsers.peerUsers.map(
                                    (person: any, index: number) => (
                                      <div className="col-span-1" key={index}>
                                        <Card className="p-2">
                                          <div className="w-full flex gap-2">
                                            <div className="text-center border-r pe-2">
                                              <img
                                                src={
                                                  process.env.STATIC_PATH +
                                                  "/images/user.jpg"
                                                }
                                                className="text-center w-12 h-12 rounded-full p-1 border"
                                                alt=""
                                              />
                                            </div>
                                            <div className="flex flex-1 items-center">
                                              <div>
                                                <div className="text-xs font-bold">
                                                  {person.displayName}
                                                </div>
                                                <div className="text-xs">
                                                  {person.department}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </Card>
                                      </div>
                                    ),
                                  )
                                : ""}
                            </div>
                          )}
                        </div>
                      </CustomWidget>
                    </TabsContent>
                  )}
                  <TabsContent value="usergroups" className="mt-0.5">
                    <CustomWidget info="User groups in the AD that this user is registered in">
                      <div className="min-h-60 relative">
                        {userGroupData.length == 0 ? (
                          <div className="absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]">
                            <NoData />
                          </div>
                        ) : (
                          <DataTable
                            cols={userGroupCols}
                            data={userGroupData}
                            colFilter={false}
                            pagination={false}
                            countPerPageSelection={true}
                            totalCount={userGroupData.length}
                          />
                        )}
                      </div>
                    </CustomWidget>
                  </TabsContent>
                  {peerData && peerData.azureStatus == 1 ? (
                    //  || isFeatureAllowed(ALL_KEYS.ID_INTEL_AZURE_WIDGETS_BYPASS)
                    <TabsContent value="azureusergroups" className="mt-0.5">
                      <CustomWidget info="User groups in the AD that this user is registered in">
                        <div className="min-h-60 relative">
                          {azureUserGroupData.length == 0 ? (
                            <div className="absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]">
                              <NoData />
                            </div>
                          ) : (
                            <DataTable
                              cols={userGroupCols}
                              data={azureUserGroupData}
                              colFilter={false}
                              pagination={true}
                              countPerPageSelection={true}
                              totalCount={azureUserGroupData.length}
                            />
                          )}
                        </div>
                      </CustomWidget>
                    </TabsContent>
                  ) : (
                    ""
                  )}
                  {extraTabs
                    ? extraTabs.map((tab: any, index: number) => (
                        <TabsContent
                          value={tab.id}
                          key={index}
                          id={tab.id}
                        ></TabsContent>
                      ))
                    : ""}
                </Tabs>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.account == nextProps.account &&
      prevProps.openState == nextProps.openState &&
      prevProps.filter_time == nextProps.filter_time
    );
  },
);

UserInvestigator.displayName = "UserInvestigator";

export default UserInvestigator;

// Test for merge request with commit ref
